import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators
} from "@angular/forms";
import { MatTableDataSource } from '@angular/material/table';
import { DadosPessoaisAba1Response } from 'app/auth/_models/DadosPessoaisAba1';
import { Enum } from 'app/model/enum';
import { OutroVinculo } from 'app/model/outroVinculo';
import { EnumService } from 'app/service/enum/enum';
import { FinalizarRecadastramentoService } from 'app/service/finalizar-recadastramento';
import { OutroVinculoService } from 'app/service/outro.vinculo';
import { RelatorioService } from 'app/service/relatorio.service';
import { ToastrService } from 'ngx-toastr';
import { saveAs } from 'file-saver';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../modal/modal.component';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import {Observable} from "rxjs/internal/Observable";
import {MaskUtil} from "../../utils/mask-util";
import { DadosPessoaisAba1 } from "../../service/dados-pessoais-aba1/dados-pessoais-aba1";
@Component({
  selector: 'app-recadastramento-aba14',
  templateUrl: './recadastramento-aba14.component.html',
  styleUrls: ['./recadastramento-aba14.component.sass']
})
export class RecadastramentoAba14Component implements OnInit{

  @Input() dadosPessoaisUser: any;
  @Input() mostrarAlerta: any;
  @Output() voltarPagina: EventEmitter<void> = new EventEmitter<void>();
  @Output() dadosSalvos: EventEmitter<void> = new EventEmitter<void>();
  @Output() formularioSalvo = new EventEmitter<void>();
  formVinculo: FormGroup;
  user: DadosPessoaisAba1Response = null

  isLoading: boolean = true;
  isInfoImportantVisible: boolean = true
  isLoadingSpinner: boolean = false
  desabilitarTipoInscricao: boolean = true

  categorias: Enum[];
  vinculos: OutroVinculo[]

  // tabela
  outrosVinculos: OutroVinculo[] = []
  displayedColumns: string[] = ['cpf', 'cnpj', 'categoria', 'acao'];
  dataSource = new MatTableDataSource<OutroVinculo>([]);
  cpfLogado: number = null;

  constructor(
      private formBuilder: FormBuilder,
      private enumService: EnumService,
      private outroVinculoService: OutroVinculoService,
      private finalizarRecadastramentoService: FinalizarRecadastramentoService,
      private relatorioService: RelatorioService,
      private toastrService: ToastrService,
      public dialog: MatDialog,
      private router: Router,
      private dadosPessoaisAba1Service: DadosPessoaisAba1
  ) {
    this.user = JSON.parse(sessionStorage.getItem('SessionDataUserAuth'));

  }

  ngOnInit(): void {
    this.carregarDadosInicias();
    this.formVinculo = this.formBuilder.group({
      possuiVinculo: ['N'],
      tpInscricao: [''],
      cpf: ['', [Validators.required, MaskUtil.validateCpfFormBuilder]],
      cnpj: ['', [Validators.required, MaskUtil.validateCnpjFormBuilder]],
      categoria: ['', Validators.required],
      declaracao: false
    });
  }

  carregarDadosInicias(flChangeEvent?: boolean){
    var obterVinculos = this.outroVinculoService.obterVinculos();
    var buscarCategorias = this.enumService.buscarCategoriaTrabalho();
    var dadosPessoais = this.dadosPessoaisAba1Service.getDadosPessoais();
    forkJoin([buscarCategorias, obterVinculos, dadosPessoais]).subscribe(([categorias, vinculos, dadoPessoal]) => {
      this.categorias = categorias;
      this.outrosVinculos = vinculos;
      this.cpfLogado = dadoPessoal.cpf;
      if(!flChangeEvent){
        this.outrosVinculos.length > 0  ? this.formVinculo.get('possuiVinculo').setValue('S') : this.formVinculo.get('possuiVinculo').setValue('N');
      }
      this.outrosVinculos.map(vinculo => {
        vinculo.categoriaDescricao = this.categorias.find(categoria => categoria.codigo == vinculo.categoria).descricao
      })
      this.atualizarTabela()
    })
  }

  onChangePossuiVinculo(field: any) {
    if (field.value == 'N') {
      this.formVinculo.get('tpInscricao').setValue('')
      this.formVinculo.get('possuiVinculo').setValue('N')
      this.dataSource.data = []
    } else {
      this.carregarDadosInicias(true);
    }
  }

  cpfUniqueValidator(event: any): void {
      if (this.cpfLogado == MaskUtil.maskToCpf(event.target.value)) {
        this.formVinculo.controls['cpf'].setErrors({cpfLogado: true});
      }
  }

  private processForkJoin(buscarCategorias: Observable<Enum[]>, obterVinculos: Observable<OutroVinculo[]>) {
    forkJoin([buscarCategorias, obterVinculos]).subscribe(([categorias, vinculos]) => {
      this.categorias = categorias
      this.outrosVinculos = vinculos


    })
  }

  onChangeTipoInscricao(field: any) {
    if (field.value == 'CPF') {
      this.formVinculo.get('cnpj').setValue('')
    } else if (field.value == 'CNPJ') {
      this.formVinculo.get('cpf').setValue('')
    }
  }

  desabilitarCombo() {
    return this.user.tipoMatricula != 3 && this.user.tipoMatricula != 6
  }

  toggleInfoImportantVisible() {
    this.isInfoImportantVisible = !this.isInfoImportantVisible;
  }

  adicionar() {
    if (this.camposValidados()) {

      var cpf = this.formVinculo.get('cpf').value
      var cnpj = this.formVinculo.get('cnpj').value
      var categoria = this.formVinculo.get('categoria').value
      var categoriaDescricao = this.categorias.find(cat => cat.codigo === categoria)?.descricao || '';
      var tipo = cnpj ? 1 : 2

      this.outrosVinculos.push(new OutroVinculo(cpf, cnpj, tipo, categoria, categoriaDescricao))
      this.limparFormVinculo()
      this.atualizarTabela()
    }
  }

  camposValidados(): boolean {
    this.formVinculo.controls[this.formVinculo.get('tpInscricao').value == 'CPF' ? 'cnpj' : 'cpf'].setErrors(null)
    return this.formVinculo.valid
  }

  removerVinculo(vinculoRemover: any) {
    this.outrosVinculos = this.outrosVinculos.filter(vinculo => vinculo != vinculoRemover)
    this.atualizarTabela();

    if (vinculoRemover.id != undefined) {
      this.outroVinculoService.deletarVinculo(vinculoRemover.id).subscribe(() => {
        this.toastrService.success('Registro apagado com sucesso')
      })
    }
    this.outrosVinculos.length < 1 ? this.formVinculo.get('possuiVinculo').setValue('N') : false;
  }

  atualizarTabela() {
    this.dataSource = new MatTableDataSource(this.outrosVinculos);
  }

  limparFormVinculo() {
    this.formVinculo.get('cpf').setValue('')
    this.formVinculo.get('cnpj').setValue('')
    this.formVinculo.get('categoria').setValue('')
  }

  salvarVinculo() {
    this.outroVinculoService.adicionarVinculo(this.outrosVinculos).subscribe((resp) => {
      this.outrosVinculos = this.outrosVinculos.map( v => {
        if(v.id == undefined){
          resp.filter( r => {
            if((r.cpf == v.cpf || r.cnpj == v.cnpj) && v.categoria == r.categoria ){
              v.id = r.id;
            }
          })
        }
        return v;
      })
      this.atualizarTabela();
      this.toastrService.success('Dados atualizados com sucesso!')
      this.limparCampos()
      this.avancaParaProximoTab();
    }, error => {
      this.toastrService.error(error.error.message);
    });
  }

  limparCampos() {
    this.formVinculo.get('possuiVinculo').setValue('S')
    this.formVinculo.get('tpInscricao').setValue('')
    //this.dataSource.data = []
    //this.desabilitarTipoInscricao = true
  }

  finalizarRecadastramento() {
    this.isLoadingSpinner = true
    this.finalizarRecadastramentoService.finalizarRecadastramento().subscribe(() => {
      this.toastrService.success('Recadastramento finalizado com sucesso!')

      this.relatorioService.gerarRelatorio('relatorioComprovanteRecadastramento').subscribe((resp: Blob) => {
        let blob: Blob;
        const fileType = resp.type || 'application/octet-stream';

        let fileName = 'Conclusão_Recadastramento'
        const fileExtension = this.getFileExtensionFromMimeType(fileType);

        if (fileExtension) {
          fileName += '.' + fileExtension;
        }

        blob = new Blob([resp], { type: fileType });
        this.downloadFile(blob, fileName);
        this.isLoadingSpinner = false
        this.router.navigate([''])
      })
    })
  }

  private getFileExtensionFromMimeType(mimeType: string): string | null {
    const extensionMap = {
      'application/pdf': 'pdf',
      'image/jpeg': 'jpeg',
      'image/jpg': 'jpg',
      'image/png': 'png'
    };

    return extensionMap[mimeType] || null;
  }

  downloadFile(blob: Blob, fileName: string): void {
    saveAs(blob, fileName);
    this.toastrService.success('Arquivo baixado com sucesso');
  }

  voltarPaginaAnterior() {
    this.voltarPagina.emit()
  }

  avancaParaProximoTab() {
    this.dadosSalvos.emit()
  }

  openDialog(): void {
    this.dialog.open(ModalComponent, {
      width: '450px',
      data: {
        header: 'Atenção!',
        descricao: 'Após a finalização nenhuma alteração será permitida. Deseja realmente continuar?',
        labelOne: 'Não',
        labelTwo: 'Sim',
        action: () => {
          this.finalizarRecadastramento()
        }
      }
    });
  }
}
